import { UntypedFormArray, UntypedFormGroup, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

import { Injectable } from '@angular/core';
import { PledgeProductRead } from '../../definition/interface/Pledge';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  options: any = {};
  generate(entity: any, option) {
    let scpis: UntypedFormGroup[] = [];
    const products = entity;

    if (!!products && products?.length)
      for (let scpi of products)
        scpis.push(this.formBuilder.group(this.createModel(scpi, option)));

    let group = this.formBuilder.group({
      scpis: this.formBuilder.array(scpis, Validators.nullValidator),
    });

    this.form = group;

    return group;
  }
  public createModel(entity: PledgeProductRead & { parameters: any }, option) {
    const paymentTypeDefaultValue = option?.productsType?.find(
      product => product?.name === entity.productName,
    );
    const defaultValue = option
      ? paymentTypeDefaultValue?.type?.find(
          type => type?.value === 'DIRECT_DEBIT',
        )?.value || paymentTypeDefaultValue?.type[0]?.value
      : 'DIRECT_DEBIT';

    return {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        paymentType: [
          entity?.parameters?.paymentType || defaultValue || 'DIRECT_DEBIT',
          Validators.required,
        ],
        holderIsSubscriber: [
          entity?.parameters?.holderIsSubscriber != null
            ? entity?.parameters?.holderIsSubscriber
            : true,
          Validators.required,
        ],

        directDebitIban: this.formBuilder.group({
          id: [entity?.parameters?.directDebitIban?.id || null],
          iban: [entity?.parameters?.directDebitIban?.iban || null],
          bic: [entity?.parameters?.directDebitIban?.bic || null],
          holder: [entity?.parameters?.directDebitIban?.holder || null],
          bankName: [entity?.parameters?.directDebitIban?.bankName || null],
          ownerIds: [entity?.parameters?.directDebitIban?.ownerIds || []],
        }),
        chequeAccountHolder: [entity?.parameters?.chequeAccountHolder || null],

        chequeNumber: [entity?.parameters?.chequeNumber || null],
        chequeBank: [entity?.parameters?.chequeBank || null],
        reltionshipHolderSubscriber: [
          entity?.parameters?.reltionshipHolderSubscriber || null,
        ],
        interventionReason: [
          entity?.parameters?.interventionReason || null,
        ],
        iban: [entity?.parameters?.directDebitIban || null],
      }),
    };
  }
  get scpis() {
    return this.form.get('scpis') as UntypedFormArray;
  }
  extract() {
    return { products: [...this.form.value.scpis] };
  }
}
